/**
 * MEDICLOUD REST API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 */
export const AppointmentState = {
    PLANNED: 'PLANNED',
    FINISHED: 'FINISHED'
} as const;
export type AppointmentState = typeof AppointmentState[keyof typeof AppointmentState];

